import { useMemo } from 'react';
import { getCriticalFailureReason } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { useWidgetDetails } from 'worker-connection-library/hooks/useWidgetDetails';
import { CriticalFailureReasons } from 'calling-cross-tab-library/constants/CriticalFailureReasons';
// @ts-expect-error module not found
import { isAcceptanceTest } from 'hub-http/helpers/env';
import { isFirefox } from 'UIComponents/utils/BrowserTest';
export const useShowMicrophoneErrorAlert = () => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const criticalFailureReason = getCriticalFailureReason(widgetDetails);
  const showMicrophoneErrorAlert = useMemo(() => criticalFailureReason === CriticalFailureReasons.MICROPHONE_PERMISSION_ERROR && isAcceptanceTest() === false && !isFirefox(), [criticalFailureReason]);
  return {
    showMicrophoneErrorAlert
  };
};